function adminSetting() {
  let setting = [
    {
      name: "Setting",
      icon: "Settings",
      logoName: "Settings",
      // flag: "voucherRequired",
      displayService: "adminSetting",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/AdminSetting",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];
    return dashboardArr;
  };

  const settingSub = () => {
    const profileArr = [
      {
        path: "/index/Setting",
        name: "Generate Key",
        icon: "generate key",
        logoName: "generate key",
        flag: "GENERATE KEY"
        // flag: "isProfileSetting",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };

  const bank_Master = () => {
    const profileArr = [
      {
        path: "/index/AdminBankMaster",
        name: "Bank Master",
        icon: "MyBank",
        logoName: "MyBank",
        flag: "BANK MASTER"
        // flag: "isProfileSetting",
      },
    ];
    return profileArr;
  };

  const countryMaster = () => {
    const countryMasterArr = [
      {
        path: "/index/CountrySettings",
        name: "Country Master",
        icon: "CountryMaster",
        logoName: "CountryMaster",
        flag: "COUNTRY MASTER",
      },
    ];
    return countryMasterArr;
  };

  const languageMaster = () => {
    const languageMasterArr = [
      {
        path: "/index/AdminLanguageMaster",
        name: "Language Master",
        icon: "languageMaster",
        logoName: "languageMaster",
        flag: "LANGUAGE MASTER"
       
      },
    ];
    return languageMasterArr;
  };

  const bankType = () => {
    const bankTypeArr = [
      {
        path: "/index/adminBankType",
        name: "Bank Type",
        icon: "bankType",
        logoName: "bankType",
        flag: "BANK TYPE",
      },
    ];
    return bankTypeArr;
  };

  const transferType = () => {
    const AccountTypeArr = [
      {
        path: "/index/adminTransferType",
        name: "Transfer Type",
        icon: "transferType",
        logoName: "transferType",
        flag: "TRANSFER TYPE",
      },
    ];
    return AccountTypeArr;
  };

  const accountTypeMain = () => {
    const AccountTypeArr = [
      {
        path: "/index/accountTypeAdmin",
        name: "Account Type",
        icon: "accountType",
        logoName: "accountType",
        flag: "ACCOUNT TYPE",
      },
    ];
    return AccountTypeArr;
  };

  const Push_Notification = () => {
    const PushNoticationArr = [
      {
        path: "/index/AdminPushNotification",
        name: "Push Notification",
        icon: "MyBank",
        logoName: "MyBank",
        flag: "PUSH NOTIFICATION",
      },
    ];
    return PushNoticationArr;
  };

  const SMS_Provider = () => {
    const smsProvideArrr = [
      {
        path: "/index/AdminSMSProvider",
        name: "SMS Provider",
        icon: "pinBySMS",
        logoName: "pinBySMS",
        flag: "SMS PROVIDER",
      },
    ];
    return smsProvideArrr;
  };

  const Activity_Tracker = () => {
    const activityTracker = [
      {
        path: "/index/ActivityTrackerAdmin",
        name: "Activity Trackers",
        icon: "CREATE PROOF TYPE",
        logoName: "CREATE PROOF TYPE",
        flag: "ACTIVITY TRACKERS"
      },
    ];
    return activityTracker;
  };

  const Admin_Module_Allocation = () => {
    const moduleAllocationAdmin = [
      {
        path: "/index/AdminModuleAllocationData",
        name: "Module Allocation",
        icon: "KYC Report",
        logoName: "kyc report",
        flag:"MODULE ALLOCATION"
      },
    ];
    return moduleAllocationAdmin;
  };

  let a = dashboard();
  let b = settingSub();
  let c = countryMaster();
  let d = bank_Master();
  let e = languageMaster();
  let f = bankType();
  let g = transferType();
  let h = accountTypeMain();
  let i = Push_Notification();
  let j = SMS_Provider();
  let k = Activity_Tracker();
  let l = Admin_Module_Allocation();

  setting[0].items = [...a, ...b, ...c, ...d, ...e, ...g, ...f, ...h, ...i, ...j, ...k,...l];

  return setting;
}

export default adminSetting;
